import React from 'react';

const Loadable = React.lazy(() => import('../../../pages/Sale/Detail/Detail'));

export default Loadable;
